import { api } from 'shared';
import { z } from 'zod';

export const CulinaryStudioArticleCategoriesResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            slug: z.string(),
            name: z.string(),
        }),
    ),
});
export const fetchCulinaryStudioArticleCategories = async () => (
    api.get<z.infer<typeof CulinaryStudioArticleCategoriesResponseSchema>>(
        '/culinary-studio-article-categories',
        {},
        CulinaryStudioArticleCategoriesResponseSchema,
    )
);
